module.exports = __webpack_public_path__ + "static/media/ketogainslogo.5a2825f6.png";